import { atom } from "recoil";
import { CompanyType } from "../../../types";

export const addNewCompanyModal = atom<boolean>({
  key: "addNewCompanyModal",
  default: false,
});

export const generateTokenModal = atom<boolean>({
  key: "generateTokenModal",
  default: false,
});

export const currentEditCompany = atom<CompanyType | undefined>({
  key: "currentEditCompany",
  default: undefined,
});
